// @flow

import { type IncomingPayment } from './types';

export function getPhoneNumber(incomingPayment: IncomingPayment): ?string {
  return incomingPayment['phone_number'];
}
